const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;

if (ScrollTrigger) {
  try {
    gsap.registerPlugin(ScrollTrigger);
  } catch (e) {}
}

gsap.registerPlugin(ScrollTrigger); // безопасно вызывать повторно

export default function initValuesSection() {
  document.querySelectorAll(".values").forEach((section) => {
    const row = section.querySelector(".values__row");
    const h = row.offsetHeight || row.getBoundingClientRect().height;
    row.style.minHeight = h + 'px';
    if (!row) return;

    const wheel = row.querySelector(".values__item--wheel");
    const circles = Array.from(
        row.querySelectorAll(".values__item:not(.values__item--wheel)")
    );
    if (!wheel || !circles.length) return;

    // === NEW: флаг reduce motion
    const prefersReduced =
        !!(
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
        );

    const q = (sel) => section.querySelector(sel);
    if (window.matchMedia("(max-width: 743.98px)").matches) {
      row.style.minHeight ||= "360px";
    }

    gsap.set(row, { opacity: 0 });

    function buildDesktop() {
      const rowRect = row.getBoundingClientRect();
      const wheelX = wheel.getBoundingClientRect().left - rowRect.left;

      circles.forEach((el) => {
        const elX = el.getBoundingClientRect().left - rowRect.left;
        gsap.set(el, { x: wheelX - elX, y: 16, scale: 0.98, autoAlpha: 0 });
      });

      const title = q(".values__title");
      const arrow = q(".values__arrow");
      const desc = q(".values__desc");

      gsap.set([title, arrow, desc, wheel].filter(Boolean), {
        clearProps: "all",
        autoAlpha: 0,
        y: 16,
      });

      const tl = gsap.timeline({
        defaults: { ease: "power2.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 70%",
          onEnter: (self) => {
            tl.play(0);
            self.disable();
          },
        },
      });

      tl.to([title, arrow].filter(Boolean), {
        autoAlpha: 1,
        y: 0,
        duration: 0.45,
        stagger: 0.05,
      })
          .to(desc, { autoAlpha: 1, y: 0, duration: 0.35 }, "-=0.2")
          .to(wheel, { autoAlpha: 1, y: 0, duration: 0.4 }, "-=0.1")
          .to(
              circles,
              { autoAlpha: 1, y: 0, duration: 0.32, stagger: 0.04 },
              "-=0.10"
          )
          .to(
              circles,
              {
                x: 0,
                scale: 1,
                duration: 0.85,
                ease: "power3.out",
                stagger: 0.06,
              },
              "<"
          );

      return tl;
    }

    function buildMobile() {
      const title = q(".values__title");
      const arrow = q(".values__arrow");
      const desc = q(".values__desc");
      gsap.set([title, arrow, desc].filter(Boolean), {
        autoAlpha: 1,
        x: 0,
        y: 0,
        clearProps: "transform,opacity,visibility",
      });
      gsap.set(wheel, {
        autoAlpha: 1,
        x: 0,
        y: 0,
        scale: 1,
        clearProps: "all",
      });
      gsap.set(circles, {
        autoAlpha: 1,
        x: 0,
        y: 0,
        scale: 1,
        clearProps: "all",
      });
    }

    const decodeImg = (img) => {
      if (!img) return Promise.resolve();
      if (img.complete && img.naturalWidth) return Promise.resolve();
      if (img.decode) return img.decode().catch(() => {});
      return new Promise((res) =>
          img.addEventListener("load", res, { once: true })
      );
    };
    const waitImagesIn = (root) => {
      const imgs = Array.from(root.querySelectorAll("img"));
      return imgs.length
          ? Promise.all(imgs.map(decodeImg))
          : Promise.resolve();
    };
    const waitFontsWithTimeout = (ms) => {
      if (!(document.fonts && document.fonts.ready)) return Promise.resolve();
      return Promise.race([
        document.fonts.ready,
        new Promise((res) => setTimeout(res, ms)),
      ]);
    };

    const mm = gsap.matchMedia();

    const ASSET_TIMEOUT = 1200;
    let shown = false;
    const showNow = () => {
      if (shown) return;
      shown = true;
      gsap.set(row, { visibility: "visible" });
      gsap.to(row, { opacity: 1, duration: 0.3, clearProps: "opacity" });
      row.style.removeProperty('min-height');

    };



    const failsafe = setTimeout(showNow, ASSET_TIMEOUT);

    Promise.all([waitImagesIn(section), waitFontsWithTimeout(600)]).then(() => {
      clearTimeout(failsafe);
      showNow();

      if (prefersReduced) {
        buildMobile();
      } else {
        mm.add({
          "(min-width: 744px)": () => buildDesktop(),
          "(max-width: 743.98px)": () => buildMobile(),
        });
      }
    });

    let rebuildRaf;
    window.addEventListener("resize", () => {
      cancelAnimationFrame(rebuildRaf);
      rebuildRaf = requestAnimationFrame(() => {
        ScrollTrigger.refresh();
      });
    });
  });
}
